import { ItemsLength } from 'components/features/target-achievement-support/pages/PortfolioAnalysisInvestmentProduct';
import { INVESTMENT_TRUST_TYPE } from 'components/features/target-achievement-support/utils/portfolioInfo';
import { InvestmentTrustType } from 'components/features/target-achievement-support/utils/type';
import React from 'react';

const Tab = ({
  isSelected,
  title,
  itemLength,
  onClick,
}: {
  isSelected: boolean;
  title: string;
  itemLength: number;
  onClick: () => void;
}): React.ReactElement => {
  return (
    <>
      <div
        className={`flex flex-col text-center py-1 ${
          isSelected
            ? 'text-white rounded-t'
            : 'text-black rounded-t-sm bg-gray-300'
        } ${itemLength === 0 && 'opacity-40'} cursor-pointer`}
        style={{ ...(isSelected ? { backgroundColor: '#3480ce' } : {}) }}
        onClick={onClick}>
        <div className={`text-base font-bold`}>{title}</div>
        <div className={`text-xs`}>{itemLength}件</div>
      </div>
    </>
  );
};

const investmentTrustTypeToString = (
  investmentTrustType: InvestmentTrustType
): string => {
  return (
    Object.values(INVESTMENT_TRUST_TYPE).find(
      t => t.type === investmentTrustType
    )?.label ?? ''
  );
};

type Props = {
  selectedInvestmentTrustType: InvestmentTrustType;
  setInvestmentTrustType: React.Dispatch<
    React.SetStateAction<InvestmentTrustType>
  >;
  itemsLength: ItemsLength;
  className?: (prev: string) => string;
};

export const InvestmentTrustTabs = ({
  selectedInvestmentTrustType,
  setInvestmentTrustType,
  itemsLength,
  className,
}: Props): React.ReactElement => {
  const onClickTab = (type: InvestmentTrustType): void => {
    if (type === 'JP_MF' || itemsLength[type] !== 0) {
      setInvestmentTrustType(type);
    }
  };

  return (
    <>
      <div
        className={(className ?? ((s: string): string => s))(
          `flex flex-row gap-2 border-b-3`
        )}
        style={{ borderColor: '#3480ce' }}>
        {Object.values(INVESTMENT_TRUST_TYPE)
          .map(t => t.type)
          .map((type, i) => {
            return (
              <Tab
                {...{
                  isSelected: selectedInvestmentTrustType === type,
                  title: investmentTrustTypeToString(type),
                  itemLength: itemsLength !== undefined ? itemsLength[type] : 0,
                  onClick: (): void => onClickTab(type),
                }}
                key={i}
              />
            );
          })}
      </div>
    </>
  );
};
